
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sadhguru-academy/privacy-policy",
      function () {
        return require("private-next-pages/sadhguru-academy/privacy-policy/index.ila.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sadhguru-academy/privacy-policy"])
      });
    }
  